import React from 'react';
import Employees from "../assets/images/employees.svg";
import Entities from "../assets/images/entities.svg";
import VendorSearch from "../assets/images/vender-search.svg";
import AuditReports from "../assets/images/audit-reports.svg";
import Education from "../assets/images/education.svg";
import HealthCare from "../assets/images/healthcare.svg";

const DataCategoriesAndTools = () => {
  return (
    <section className="py-5" style={{backgroundColor: "#ffffff"}}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold mb-3">Data Categories and Tools</h2>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <article className="quick-tools-card">
              <div className="quick-tools-icon icon-employees">
                <a 
                  href="/employees" target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="View Employees">
                  <img
                    src={Employees}
                    alt="Employees"
                    className="quick-tools-svg"
                  />
                </a>
              </div>
              <h3 className="quick-tools-title">Employees</h3>
            </article>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <article className="quick-tools-card">
              <div className="quick-tools-icon icon-entities">
                <a 
                  href="/entities" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="View Entities">
                  <img
                    src={Entities}
                    alt="Entities"
                    className="quick-tools-svg"
                  />
                </a>
              </div>
              <h3 className="quick-tools-title">Entities</h3>
            </article>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <article className="quick-tools-card">
              <div className="quick-tools-icon icon-vendors">
                <a 
                  href="https://old.transparent.utah.gov/vendet.php"        target="_blank" 
                  rel="noopener noreferrer" aria-label="View Vendor Search">
                  <img
                    src={VendorSearch}
                    alt="Vendor Search"
                    className="quick-tools-svg"
                  />
                </a>
              </div>
              <h3 className="quick-tools-title">Vendors</h3>
            </article>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <article className="quick-tools-card">
              <div className="quick-tools-icon icon-audits">
                <a 
                  href="https://auditor.utah.gov/audit-reports/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="View Audit Reports">
                  <img
                    src={AuditReports}
                    alt="Audit Reports"
                    className="quick-tools-svg"
                  />
                </a>
              </div>
              <h3 className="quick-tools-title">Audits</h3>
            </article>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <article className="quick-tools-card">
              <div className="quick-tools-icon icon-education">
                <a 
                  href="/public-education" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  aria-label="View Public Education">
                  <img
                    src={Education}
                    alt="Education"
                    className="quick-tools-svg"
                  />
                </a>
              </div>
              <h3 className="quick-tools-title">Education</h3>
            </article>
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6">
            <article className="quick-tools-card">
              <div className="quick-tools-icon icon-healthcare">
                <a 
                  href="/healthcare" 
                  target="_blank" 
                  rel="noopener noreferrer" aria-label="View Healthcare">
                  <img
                    src={HealthCare}
                    alt="Healthcare"
                    className="quick-tools-svg"
                />
                </a>
              </div>
              <h3 className="quick-tools-title">Healthcare</h3>
            </article>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DataCategoriesAndTools;